import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import { FileTransfer } from '@ionic-native/file-transfer';
import { LoopBackConfig } from '../../sdk/lb.config';
import { Storage } from "@ionic/storage";
import { NestAuthProvider } from '../nest-auth';
import { StoragePathProvider } from '../../../providers/storage-path/storage-path';
import { File } from '@ionic-native/file';
import { Observable } from 'rxjs';
import { NestApiProvider } from '../nest-api';
import { Paginate } from '../../../model/paginate';

@Injectable()
export class GDAttendanceCorrectionApiProvider {

  module: string = 'attendance';

  accessToken: any;
  headerOptions: any;
  headerOptionsJson: any;
  attendancePath: any = LoopBackConfig.getPath();
  timeout: number = 30000;

  constructor(
    public http: HttpClient,
    public storage: Storage,
    public platform: Platform,
    public nestAuth: NestAuthProvider,
    public transfer: FileTransfer,
    public file: File,
    public storagePathProvider: StoragePathProvider,
    public nestApi: NestApiProvider
  ) {

  }

  getHistory(formData) {
    const method: string = "POST";
    const model: string = "attendanceCorrectionRequest";
    const func: string = "getHistory";
    const params: any = {};
    const urlParams: any = formData;
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request<Paginate<any>>(method, url, params, urlParams, body, contentType);
  }


  saveDraft(formData): Observable<any> {
    const method: string = "POST";
    const model: string = "attendanceCorrectionRequest";
    const func: string = "saveDraft";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  add(formData): Observable<any> {
    const method: string = "POST";
    const model: string = "attendanceCorrectionRequest";
    const func: string = "add";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  reject(formData): Observable<any> {
    const method: string = "POST";
    const model: string = "attendanceCorrectionRequest";
    const func: string = "reject";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  revise(formData): Observable<any> {
    const method: string = "POST";
    const model: string = "attendanceCorrectionRequest";
    const func: string = "revise";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  approve(formData): Observable<any> {
    const method: string = "POST";
    const model: string = "attendanceCorrectionRequest";
    const func: string = "approve";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  cancel(requestNo: string, companyId: number): Observable<any> {
    const method: string = "POST";
    const model: string = "attendanceCorrectionRequest";
    const func: string = "cancel";
    const params: any = { requestNo: requestNo, companyId: companyId };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  deleteDraft(requestNo: string, companyId: number): Observable<any> {
    const method: string = "POST";
    const model: string = "attendanceCorrectionRequest";
    const func: string = "deleteDraft";
    const params: any = { requestNo: requestNo, companyId: companyId };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  getRequestDetail(requestNo: string, companyId: number): Observable<any> {
    const method: string = "POST";
    const model: string = "attendanceCorrectionRequest";
    const func: string = "getRequestDetail";
    const params: any = { requestNo: requestNo, companyId: companyId };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  getRequest(requestNo: string): Observable<any> {
    const method: string = "POST";
    const model: string = "attendanceCorrectionRequest";
    const func: string = "getRequest";
    const params: any = { requestNo: requestNo };
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  getShiftDaily(): Observable<any> {
    const method: string = "POST";
    const model: string = "attendanceCorrectionRequest";
    const func: string = "getShiftDaily";
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

  attCorrListPage(formData): Observable<any> {
    const method: string = "POST";
    const model: string = "attendanceCorrectionRequest";
    const func: string = "attCorrListPage";
    const params: any = formData;
    const urlParams: any = {};
    const body: any = {};
    const contentType = 'json';

    const url = this.nestApi.urlBuilder(method, model, func, params, urlParams, this.module);
    return this.nestApi.request(method, url, params, urlParams, body, contentType);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/attendance/gd-attendance-correction-api.ts